import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-left-text-block',
  templateUrl: './left-text-block.component.html',
  styleUrls: ['./left-text-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeftTextBlockComponent {
  @Input() public iconName: string;
  @Input() public title: string;
  @Input() public text: string;
  @Input() public textColorClass = 'primary-color-60';
  @Input() public titleClasses: string;
  @Input() public textClasses: string;
  @Input() public transitionName: string;
  @Input() public transitionLink: string;
  @Input() public defaultTitleHeight: number;

  public icons = CustomIcons;
  public breakPointObserve$ = this.breakpointObserver.observe(['(max-width: 1250px)']);
  constructor(private breakpointObserver: BreakpointObserver) {}
}
